var icon = require('vue-svgicon')
icon.register({
  'ks-icon-check': {
    width: 128,
    height: 128,
    viewBox: '0 0 128 128',
    data: '<path pid="0" d="M52.86 106.15L121 38l-13.72-13.71L52.86 78.6l-30.07-30L9.06 62.34z"/>'
  }
})
